type Color = string;
type GradientColor = Record<number, Color>;
export const green: GradientColor = {
  100: '#e2f2ee',
  200: '#b4e2d8',
  300: '#84d0bf',
  400: '#54bca6',
  500: '#169e82',
  600: '#0f8066',
  700: '#00543c',
  800: '#003526',
  900: '#00251b',
} as const;

export const neutral: GradientColor = {
  0: '#fff',
  100: '#f6f7f8',
  200: '#e9ebec',
  300: '#cfd4d8',
  400: '#abb2ba',
  500: '#9199a1',
  600: '#6f7780',
  700: '#585f66',
  800: '#41474c',
  900: '#1f2226',
};

export const red: GradientColor = {
  700: '#A23210',
  800: '#71240E',
  900: '#4A1A0C',
};

export const beige: Color = '#f7f5ed';

/** DEPRECATED **/
export const inkExtraLight = '#ebecef';
export const inkLighter = '#adb5bd';
export const inkLight = '#868e96';
export const ink = '#343a40';
